webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14cf91c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2709fdc7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_index__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_home_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_login_index__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_register_index__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_register_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_register_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_bookrack_index__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_bookrack_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_bookrack_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_search_index__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_search_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_search_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_classify_index__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_classify_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_classify_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_rank_index__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_rank_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_rank_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_women_index__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_women_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_women_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_men_index__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_men_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_men_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_booklist_index__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_booklist_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_booklist_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_classifydetails_index__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_classifydetails_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_classifydetails_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_BookDetails__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_BookDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_BookDetails__);


// import Hello from '@/components/Hello'














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_index___default.a
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_index___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_login_index___default.a
  }, {
    path: '/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_4__views_register_index___default.a
  }, {
    path: '/bookrack',
    name: 'Bookrack',
    component: __WEBPACK_IMPORTED_MODULE_5__views_bookrack_index___default.a
  }, {
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_6__views_search_index___default.a
  }, {
    path: '/classify',
    name: 'Classify',
    component: __WEBPACK_IMPORTED_MODULE_7__views_classify_index___default.a
  }, {
    path: '/rank',
    name: 'Rank',
    component: __WEBPACK_IMPORTED_MODULE_8__views_rank_index___default.a
  }, {
    path: '/women',
    name: 'Women',
    component: __WEBPACK_IMPORTED_MODULE_9__views_women_index___default.a
  }, {
    path: '/men',
    name: 'Men',
    component: __WEBPACK_IMPORTED_MODULE_10__views_men_index___default.a
  }, {
    path: '/booklist',
    name: 'Booklist',
    component: __WEBPACK_IMPORTED_MODULE_11__views_booklist_index___default.a
  }, {
    path: '/bookdetails/:title?&:catalogId?',
    name: 'BookDetails',
    component: __WEBPACK_IMPORTED_MODULE_13__components_BookDetails___default.a
  }, {
    path: '/classifydetails/:classifydetailsId?&:classifydetailsTitle?',
    name: 'Classifydetails',
    component: __WEBPACK_IMPORTED_MODULE_12__views_classifydetails_index___default.a
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_index___default.a
  }]
}));

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/failImg.8bc92f8.jpg";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lazyImg.098e370.gif";

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3dcb624e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(47);
  __webpack_require__(133);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Recommend__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Recommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Recommend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_iview___default.a);
var jsonp = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bookDetails',
  data: function data() {
    return {
      showIntro: true,
      showDetails: false,
      bookDetail: {},
      linkList: []
    };
  },

  created: function created() {
    this.getDetail();
  },
  watch: {
    $route: function $route() {
      this.getDetail();
    }
  },
  methods: {
    getDetail: function getDetail() {
      var routerTitle = this.$route.params.title;
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + self.$route.params.catalogId + '&pn=0&rn=30', null, function (err, res) {
        if (err) {
          console.error(err.message);
        } else if (res.result == null) {
          console.log('超出每日请求次数！');
          self.getLocalData(self.$route.params.catalogId).then(function (localData) {
            self.bookDetail = localData.result.data.filter(function (item) {
              return item.title == routerTitle;
            })[0];
            self.getLink();
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('请求API成功！');
          self.bookDetail = res.result.data.filter(function (item) {
            return item.title == routerTitle;
          })[0];
          self.getLink();
        }
      });
    },
    getLink: function getLink() {
      this.linkList = [];
      var linkStr = this.bookDetail.online;
      var linkArr = linkStr.split(' ');
      var self = this;
      linkArr.forEach(function (item, index) {
        var obj = {};
        var arr = item.split(':');
        obj.linkName = arr[0];
        obj.link = arr[1] + ':' + arr[2];
        self.linkList.push(obj);
      });
    },
    changeShowIntro: function changeShowIntro() {
      this.showIntro = true;
      this.showDetails = false;
    },
    changeShowDetails: function changeShowDetails() {
      this.showIntro = false;
      this.showDetails = true;
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-10p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localData = JSON.parse(res);
            success(localData);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    },
    addBookrack: function addBookrack() {
      if (localStorage.getItem('books') == null) {
        this.MyGlobal.bookrackList = { "list": [] };
        var addObj = { "catalog": this.$route.params.catalogId, "title": this.$route.params.title };
        this.MyGlobal.bookrackList.list.push(addObj);
        localStorage.setItem('books', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.MyGlobal.bookrackList));
        this.$Message.info('已成功加入书架！');
      } else {
        var localArr = this.MyGlobal.bookrackList.list;
        var canStorage = true;
        for (var i = 0; i < localArr.length; i++) {
          if (localArr[i].title == this.$route.params.title) {
            canStorage = false;
            break;
          }
        }
        if (canStorage) {
          var _addObj = { "catalog": this.$route.params.catalogId, "title": this.$route.params.title };
          this.MyGlobal.bookrackList.list.push(_addObj);
          localStorage.setItem('books', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.MyGlobal.bookrackList));
          this.$Message.info('已成功加入书架！');
        } else {
          this.$Message.info('书架已存在此书<p style="text-indent:2em;">请勿重复添加！</p>');
        }
      }
    }
  },
  components: {
    recommend: __WEBPACK_IMPORTED_MODULE_4__components_Recommend___default.a,
    bookDetailsFooter: __WEBPACK_IMPORTED_MODULE_5__components_Footer___default.a
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer'
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


var bookrackList = JSON.parse(localStorage.getItem('books'));

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  bookrackList: bookrackList
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Recommend__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Recommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Recommend__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);
var jsonp = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Content',
  data: function data() {
    return {
      aa: 66,
      catalogArr: [],
      catalogBody: { 242: [], 243: [], 244: [], 245: [], 246: [], 247: [], 248: [], 249: [], 250: [], 251: [], 252: [], 253: [], 254: [], 255: [], 256: [], 257: [], 258: [] }
    };
  },
  created: function created() {
    this.getCatalog();
  },
  methods: {
    getCatalog: function getCatalog() {
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/catalog?dtype=&key=33045ad8111771bffe55d1310ff688a4', null, function (err, data) {
        if (err) {
          console.error(err.message);
        } else if (data.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalCatalog().then(function (localCatalog) {
            self.catalogArr = localCatalog.result;
            self.catalogArr.forEach(function (item, index) {
              self.getLocalData(item.id).then(function (localData) {
                self.catalogBody[item.id] = localData.result.data;
              }).catch(function (error) {
                console.log(error);
              });
            });
            //console.log(self.catalogBody);
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.catalogArr = data.result;
          self.catalogArr.forEach(function (item, index) {
            self.getAPIData(item.id).then(function (APIData) {
              self.catalogBody[item.id] = APIData.result.data;
            }).catch(function (error) {
              console.log(error);
            });
          });
        }
      });
    },
    getLocalCatalog: function getLocalCatalog() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/catalog.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-6p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localData = JSON.parse(res);
            success(localData);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    },
    getAPIData: function getAPIData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + id + '&pn=0&rn=6', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            success(res);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    }
  },
  components: {
    recommend: __WEBPACK_IMPORTED_MODULE_3__components_Recommend___default.a
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_iview___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topbar'
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);
var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recommend',
  data: function data() {
    return {
      recomArr: [],
      recomCatalog: 0,
      isShowRecom: false,
      showImg: false
    };
  },

  created: function created() {
    this.changeRecom();
  },
  methods: {
    changeRecom: function changeRecom() {
      var ranNum = parseInt(Math.random() * 17 + 242);
      this.recomCatalog = ranNum;
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + ranNum + '&pn=0&rn=2', null, function (err, res) {
        if (err) {
          console.error(err.message);
        } else if (res.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalData(ranNum).then(function (localData) {
            self.recomArr = localData.result.data;
            self.isShowRecom = true;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.recomArr = res.result.data;
          var cutArr = res.result.data[1].sub2.split('<p>');
          var cutStr = '<p>' + cutArr[1];
          self.recomArr[1].sub2 = cutStr;
          self.isShowRecom = true;
        }
        //console.log(self.recomCatalog,self.recomArr);
      });
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-6p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localData = JSON.parse(res);
            success(localData);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    },
    imgLoad: function imgLoad() {
      this.showImg = true;
    },
    imgError: function imgError() {
      this.showImg = false;
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

// swiper options example:
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'carrousel',
  data: function data() {
    return {
      swiperOption: {
        // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
        // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // swiper configs 所有的配置同swiper官方api配置
        autoplay: 3000,
        direction: 'horizontal',
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        scrollbar: '.swiper-scrollbar',
        mousewheelControl: true,
        observeParents: true,
        // if you need use plugins in the swiper, you can config in here like this
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        onTransitionStart: function onTransitionStart(swiper) {
          //console.log(swiper)
        }
      }
    };
  },

  // you can find current swiper instance object like this, while the notNextTick property value must be true
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //console.log('this is current swiper instance object', this.swiper)
    this.swiper.slideTo(3, 1000, false);
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'booklist',
  data: function data() {
    return {
      rankList: [],
      catalogId: []
    };
  },

  components: {
    classifyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalogArr();
    this.getAPIData();
  },
  methods: {
    getCatalogArr: function getCatalogArr() {
      for (var i = 242; i <= 258; i++) {
        this.catalogId.push(i);
      }
    },
    getAPIData: function getAPIData() {
      var self = this;
      this.catalogId.forEach(function (id, index) {
        jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + id + '&pn=0&rn=6', null, function (err, data) {
          if (err) {
            console.error(err.message);
          } else if (data.result == null) {
            console.log('超过每日请求次数！');
            self.getLocalData(id).then(function (localCatalog) {
              localCatalog.result.data.forEach(function (item, index) {
                item.id = id;
                self.rankList.push(item);
              });
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            console.log('API请求数据成功！');
            data.result.data.forEach(function (item, index) {
              self.rankList.push(item);
            });
          }
        });
      });
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-6p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    }
  },
  computed: {
    rankSort: function rankSort() {
      function compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        };
      }
      this.rankList.forEach(function (item, index, arr) {
        item.reading = item.reading.replace(/人阅读/, '');
      });
      for (var i = 0; i < this.rankList.length - 1; i++) {
        var title = this.rankList[i].title;
        var nextTitle = this.rankList[i + 1].title;
        if (title == nextTitle) {
          this.rankList.splice(i, 1);
        }
      }
      var rankSortArr = this.rankList.sort(compare('reading'));
      return rankSortArr.filter(function (item) {
        return item.reading >= 10000;
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Recommend__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Recommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Recommend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Footer__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bookrack',
  data: function data() {
    return {
      bookrackList: this.MyGlobal.bookrackList.list,
      bookDetailList: []
    };
  },

  components: {
    recommend: __WEBPACK_IMPORTED_MODULE_2__components_Recommend___default.a,
    bookrackFooter: __WEBPACK_IMPORTED_MODULE_3__components_Footer___default.a
  },
  created: function created() {
    this.getDetail();
  },
  methods: {
    getDetail: function getDetail() {
      var self = this;
      if (this.bookrackList.length == 0) {
        return;
      }
      this.bookrackList.forEach(function (item, index) {
        jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + item.catalog + '&pn=0&rn=30', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else if (res.result == null) {
            console.log('超出每日请求次数！');
            self.getLocalData(item.catalog).then(function (localData) {
              var localObj = localData.result.data.filter(function (localItem) {
                return localItem.title == item.title;
              })[0];
              localObj.catalogId = item.catalog;
              self.bookDetailList.push(localObj);
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            console.log('请求API成功！');
            var localObj = res.result.data.filter(function (localItem) {
              return localItem.title == item.title;
            })[0];
            localObj.catalogId = item.catalog;
            self.bookDetailList.push(localObj);
          }
        });
      });
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-10p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localData = JSON.parse(res);
            success(localData);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    },
    clearBookrack: function clearBookrack() {
      var clearList = [];
      this.MyGlobal.bookrackList.list = clearList;
      this.bookrackList = clearList;
      localStorage.setItem('books', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.MyGlobal.bookrackList));
    }
  },
  watch: {
    bookrackList: function bookrackList() {}
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'classify',
  data: function data() {
    return {
      catalogList: []
    };
  },

  components: {
    classifyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalog();
  },
  methods: {
    getCatalog: function getCatalog() {
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/catalog?dtype=&key=33045ad8111771bffe55d1310ff688a4', null, function (err, data) {
        if (err) {
          console.error(err.message);
        } else if (data.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalCatalog().then(function (localCatalog) {
            self.catalogList = localCatalog.result;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.catalogList = data.result;
        }
      });
    },
    getLocalCatalog: function getLocalCatalog() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/catalog.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var jsonp = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'classifydetails',
  data: function data() {
    return {
      classifydetailsList: [],
      catalogId: this.$route.params.classifydetailsId
    };
  },

  created: function created() {
    this.getAPIData();
  },
  methods: {
    getAPIData: function getAPIData() {
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + self.$route.params.classifydetailsId + '&pn=0&rn=30', null, function (err, res) {
        if (err) {
          console.error(err.message);
        } else if (res.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalData(self.$route.params.classifydetailsId).then(function (localData) {
            self.classifydetailsList = localData.result.data;
            var cutArr = localData.result.data[1].sub2.split('<p>');
            var cutStr = '<p>' + cutArr[1];
            self.classifydetailsList[1].sub2 = cutStr;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.classifydetailsList = res.result.data;
          var cutArr = res.result.data[1].sub2.split('<p>');
          var cutStr = '<p>' + cutArr[1];
          self.classifydetailsList[1].sub2 = cutStr;
        }
      });
    },
    getLocalData: function getLocalData(id) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-10p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localData = JSON.parse(res);
            success(localData);
          }
        });
      }, function (fail) {
        fail('获取本地书籍详情数据出错！');
      });
    }
  },
  components: {
    classifydetailsFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Swiper__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IndexTopbar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IndexTopbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_IndexTopbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IndexContent__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IndexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_IndexContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default.a);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      bg: __webpack_require__(156)
    };
  },
  components: {
    indexTopbar: __WEBPACK_IMPORTED_MODULE_3__components_IndexTopbar___default.a,
    swiper: __WEBPACK_IMPORTED_MODULE_2__components_Swiper___default.a,
    indexContent: __WEBPACK_IMPORTED_MODULE_4__components_IndexContent___default.a,
    indexFooter: __WEBPACK_IMPORTED_MODULE_5__components_Footer___default.a
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      userName: '',
      password: '',
      authCode: '',
      error: ''
    };
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'men',
  data: function data() {
    return {
      catalogList: []
    };
  },

  components: {
    classifyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalog();
  },
  methods: {
    getCatalog: function getCatalog() {
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/catalog?dtype=&key=33045ad8111771bffe55d1310ff688a4', null, function (err, data) {
        if (err) {
          console.error(err.message);
        } else if (data.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalCatalog().then(function (localCatalog) {
            self.catalogList = localCatalog.result.filter(function (item) {
              return item.id > 251;
            });
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.catalogList = data.result.filter(function (item) {
            return item.id > 251;
          });
        }
      });
    },
    getLocalCatalog: function getLocalCatalog() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/catalog.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rank',
  data: function data() {
    return {
      rankList: [],
      catalogId: []
    };
  },

  components: {
    classifyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalogArr();
    this.getAPIData();
  },
  methods: {
    getCatalogArr: function getCatalogArr() {
      for (var i = 242; i <= 258; i++) {
        this.catalogId.push(i);
      }
    },
    getAPIData: function getAPIData() {
      var self = this;
      this.catalogId.forEach(function (id, index) {
        jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + id + '&pn=0&rn=6', null, function (err, data) {
          if (err) {
            console.error(err.message);
          } else if (data.result == null) {
            console.log('超过每日请求次数！');
            self.getLocalData(id).then(function (localCatalog) {
              localCatalog.result.data.forEach(function (item, index) {
                item.id = id;
                self.rankList.push(item);
              });
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            console.log('API请求数据成功！');
            data.result.data.forEach(function (item, index) {
              self.rankList.push(item);
            });
          }
        });
      });
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-6p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    }
  },
  computed: {
    rankSort: function rankSort() {
      function compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        };
      }
      this.rankList.forEach(function (item, index, arr) {
        item.reading = item.reading.replace(/人阅读/, '');
      });
      for (var i = 0; i < this.rankList.length - 1; i++) {
        var title = this.rankList[i].title;
        var nextTitle = this.rankList[i + 1].title;
        if (title == nextTitle) {
          this.rankList.splice(i, 1);
        }
      }
      var rankSortArr = this.rankList.sort(compare('reading')).reverse();
      return rankSortArr.filter(function (item) {
        return item.reading >= 10000;
      });
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  data: function data() {
    return {
      phone: '',
      error: ''
    };
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      searchMsg: '',
      showCloseIcon: false,
      showRecomSearch: true,
      showSearchList: false,
      showSearchResult: false,
      searchListArr: [],
      searchResultArr: [],
      searchHistoryList: [],
      recomSearchArr: [{ title: "微观历史", id: "242" }, { title: "舞遍全球", id: "252" }, { title: "王子与贫儿", id: "244" }, { title: "明朝那些事儿", id: "248" }, { title: "爱的艺术", id: "257" }, { title: "与狼共舞", id: "243" }, { title: "许愿树", id: "251" }, { title: "浮沉", id: "255" }, { title: "梁山政治", id: "254" }],
      rankList: [],
      catalogId: []
    };
  },

  components: {
    searchFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalogArr();
    this.getAPIData();
  },
  methods: {
    getSearch: function getSearch() {
      if (this.searchMsg) {
        var self = this;
        this.searchListArr = this.rankList.filter(function (item) {
          var pat = eval("/" + self.searchMsg + "/ig");
          return pat.test(item.title) || pat.test(item.sub1);
        });
      }
      this.showCloseIcon = true;
      this.showSearchList = true;
      this.showRecomSearch = false;
    },
    clearSearchMsg: function clearSearchMsg() {
      this.searchMsg = '';
      this.showCloseIcon = false;
      this.showSearchList = false;
      this.showRecomSearch = true;
    },
    showSearchData: function showSearchData(search) {
      this.searchHistoryList.push(search);
      this.searchResultArr = this.handleSearchListArr.filter(function (item) {
        return item.title == search;
      });
      this.showRecomSearch = false;
      this.showSearchList = false;
      this.showSearchResult = true;
    },
    getCatalogArr: function getCatalogArr() {
      for (var i = 242; i <= 258; i++) {
        this.catalogId.push(i);
      }
    },
    getAPIData: function getAPIData() {
      var self = this;
      this.catalogId.forEach(function (id, index) {
        jsonp('http://apis.juhe.cn/goodbook/query?key=33045ad8111771bffe55d1310ff688a4&catalog_id=' + id + '&pn=0&rn=6', null, function (err, data) {
          if (err) {
            console.error(err.message);
          } else if (data.result == null) {
            console.log('超过每日请求次数！');
            self.getLocalData(id).then(function (localCatalog) {
              localCatalog.result.data.forEach(function (item, index) {
                item.id = id;
                self.rankList.push(item);
              });
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            console.log('API请求数据成功！');
            data.result.data.forEach(function (item, index) {
              self.rankList.push(item);
            });
          }
        });
      });
      for (var i = 0; i < this.rankList.length - 1; i++) {
        var title = this.rankList[i].title;
        var nextTitle = this.rankList[i + 1].title;
        if (title == nextTitle) {
          this.rankList.splice(i, 1);
        }
      }
    },
    getLocalData: function getLocalData(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/' + id + '-6p.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    },
    clearHistory: function clearHistory() {
      this.searchHistoryList = [];
    }
  },
  computed: {
    handleSearchListArr: function handleSearchListArr() {
      for (var i = 0; i < this.searchListArr.length - 1; i++) {
        var title = this.searchListArr[i].title;
        var nextTitle = this.searchListArr[i + 1].title;
        if (title == nextTitle) {
          this.searchListArr.splice(i, 1);
        }
      }
      return this.searchListArr;
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var jsonp = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'women',
  data: function data() {
    return {
      catalogList: []
    };
  },

  components: {
    classifyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  created: function created() {
    this.getCatalog();
  },
  methods: {
    getCatalog: function getCatalog() {
      var self = this;
      jsonp('http://apis.juhe.cn/goodbook/catalog?dtype=&key=33045ad8111771bffe55d1310ff688a4', null, function (err, data) {
        if (err) {
          console.error(err.message);
        } else if (data.result == null) {
          console.log('超过每日请求次数！');
          self.getLocalCatalog().then(function (localCatalog) {
            self.catalogList = localCatalog.result.filter(function (item) {
              return item.id <= 251;
            });
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('API请求数据成功！');
          self.catalogList = data.result.filter(function (item) {
            return item.id <= 251;
          });
        }
      });
    },
    getLocalCatalog: function getLocalCatalog() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (success) {
        jsonp('http://127.0.0.1:8089/vue/catalog.php', null, function (err, res) {
          if (err) {
            console.error(err.message);
          } else {
            var localCatalog = JSON.parse(res);
            success(localCatalog);
          }
        });
      }, function (fail) {
        fail('获取本地书籍目录数据出错！');
      });
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iview_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GlobalValue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GlobalValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_GlobalValue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_iview___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default.a, {
  preLoad: 1.3,
  error: __webpack_require__(52),
  loading: __webpack_require__(53),
  attempt: 1,
  listenEvents: ['scroll', 'mousewheel']
});




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.MyGlobal = __WEBPACK_IMPORTED_MODULE_9__components_GlobalValue___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/router.4918d9a.png";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/swiper01.99db969.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/swiper02.d05f64e.jpg";

/***/ }),
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-317b0ce4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ec1790c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0822405b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fa86e6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f9e5568",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ca081ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-373a01a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(196),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce059552",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(194),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5801f78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17128fd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(195),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cde109ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(197),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf8f61e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-249350a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar bgSubColor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topbar-right"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "android-contact",
      "color": "#fff",
      "size": "30",
      "title": "登录"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/bookrack"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "ios-bookmarks",
      "color": "#fff",
      "size": "30",
      "title": "书架"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/search"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "android-search",
      "color": "#fff",
      "size": "30",
      "title": "搜索"
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155)
    }
  })])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('recommend'), _vm._v(" "), _vm._l((_vm.catalogArr), function(cat, index) {
    return _c('div', {
      staticClass: "contentBox"
    }, [_c('div', {
      staticClass: "titleBox"
    }, [_c('div', {
      staticClass: "titleInfo"
    }, [(index % 3 == 0) ? _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#f96650",
        "size": "20"
      }
    }) : (index % 3 == 1) ? _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#789262",
        "size": "20"
      }
    }) : _c('Icon', {
      attrs: {
        "type": "bookmark",
        "color": "#276793",
        "size": "20"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "titleTxt"
    }, [_vm._v(_vm._s(cat.catalog))])], 1), _vm._v(" "), _c('div', {
      staticClass: "moreIcon"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + cat.id + '&' + cat.catalog
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "title": "更多"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-arrow-right",
        "color": "#808080",
        "size": "20"
      }
    })], 1)])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "containerBox"
    }, _vm._l((_vm.catalogBody[cat.id]), function(body) {
      return _c('div', {
        staticClass: "bookBox"
      }, [_c('router-link', {
        attrs: {
          "exact": "",
          "to": '/bookdetails/' + body.title + '&' + cat.id
        }
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (body.img),
          expression: "body.img"
        }],
        staticClass: "bookImg"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(body.title))])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "bottomBox"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": "/classify",
        "tag": "p"
      }
    }, [_vm._v("\n        查看更多\n        "), _c('Icon', {
      attrs: {
        "type": "ios-arrow-thin-right",
        "size": "12"
      }
    })], 1)], 1)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-router"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("回首页")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/bookrack"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("我的书架")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/register"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("注册")])])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("回顶部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_vm._v("\n      版权所有 北京恺兴文化传媒有限公司\n      "), _c('br'), _vm._v("\n      京ICP备11033518号\n      "), _c('br'), _vm._v("\n      京网文（2016）1179-149号\n      "), _c('br'), _vm._v("\n      京ICP证111027号\n      "), _c('br'), _vm._v("\n      © 2013-2016 chuangbie.com, all rights reserved\n      "), _c('br'), _vm._v("\n      客服 4008884032 QQ:613762569\n  ")])
}]}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "rank-container"
  }, [_c('ul', _vm._l((_vm.rankSort), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id,
        "tag": "a"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("人气:" + _vm._s(item.reading))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("排行页面")])])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "women"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-container"
  }, [_c('ul', _vm._l((_vm.catalogList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + item.id + '&' + item.catalog,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.catalog))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("女生专区")])])
}]}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommendBox"
  }, [_c('div', {
    staticClass: "titleBox"
  }, [_c('div', {
    staticClass: "titleInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-star",
      "color": "#FFD700",
      "size": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "titleTxt"
  }, [_vm._v("精品推荐")])], 1)]), _vm._v(" "), (_vm.isShowRecom) ? _c('div', {
    staticClass: "recomBookBox"
  }, [_c('div', {
    staticClass: "recomBook-wrap"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": '/bookdetails/' + _vm.recomArr[0].title + '&' + _vm.recomCatalog
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.recomArr[0].img),
      expression: "recomArr[0].img"
    }],
    staticClass: "recomBookImg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "recomBookInfo"
  }, [_c('p', {
    staticClass: "recomBook-title"
  }, [_vm._v(_vm._s(_vm.recomArr[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-catalog"
  }, [_vm._v("分类：" + _vm._s(_vm.recomArr[0].catalog))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-reading"
  }, [_vm._v("人气：" + _vm._s(_vm.recomArr[0].reading))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-sub2",
    domProps: {
      "innerHTML": _vm._s(_vm.recomArr[0].sub2)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "recomBook-wrap"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": '/bookdetails/' + _vm.recomArr[1].title + '&' + _vm.recomCatalog
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.recomArr[1].img),
      expression: "recomArr[1].img"
    }],
    staticClass: "recomBookImg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "recomBookInfo"
  }, [_c('p', {
    staticClass: "recomBook-title"
  }, [_vm._v(_vm._s(_vm.recomArr[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-catalog"
  }, [_vm._v("分类：" + _vm._s(_vm.recomArr[1].catalog))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-reading"
  }, [_vm._v("人气：" + _vm._s(_vm.recomArr[1].reading))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-sub2",
    domProps: {
      "innerHTML": _vm._s(_vm.recomArr[1].sub2)
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottomBox"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.changeRecom()
      }
    }
  }, [_vm._v("\n      换一换\n      "), _c('Icon', {
    attrs: {
      "type": "android-refresh",
      "size": "12"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookDetails"
  }, [_c('div', {
    staticClass: "bookDetails-topBar"
  }, [_c('div', {
    staticClass: "bookDetails-topNav"
  }, [_c('div', {
    staticClass: "bookDetails-topNav-left"
  }, [_c('div', {
    staticClass: "bookDetails-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-topNav-right"
  }, [_c('div', {
    staticClass: "bookDetails-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-subNav"
  }, [_c('ul', [_c('li', {
    staticClass: "bookDetails-introBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.changeShowIntro()
      }
    }
  }, [_vm._v("作品简介")])]), _vm._v(" "), _c('li', {
    staticClass: "bookDetails-detailsBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.changeShowDetails()
      }
    }
  }, [_vm._v("内容详情")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-container"
  }, [_c('div', {
    staticClass: "bookDetails-containerInfo"
  }, [(_vm.showIntro) ? _c('div', {
    staticClass: "bookDetails-showIntro"
  }, [_c('div', {
    staticClass: "bookDetails-imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.bookDetail.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookDetails-bookIntro"
  }, [_c('p', {
    staticClass: "bookDetail-titleTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.title) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-catalogTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.catalog) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-tagsTxt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.tags) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-sub1Txt"
  }, [_vm._v(" " + _vm._s(_vm.bookDetail.sub1) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-readingTxt"
  }, [_vm._v(" 人气：" + _vm._s(_vm.bookDetail.reading) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDetail-bytimeTxt"
  }, [_vm._v(" 时间：" + _vm._s(_vm.bookDetail.bytime) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('div', {
    staticClass: "bookDetails-showDetails"
  }, [_c('p', {
    staticClass: "bookDetail-sub2Txt",
    domProps: {
      "innerHTML": _vm._s(_vm.bookDetail.sub2)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container-link"
  }, [_c('ul', _vm._l((_vm.linkList), function(linkItem) {
    return _c('li', [_c('a', {
      attrs: {
        "href": linkItem.link
      }
    }, [_vm._v(" " + _vm._s(linkItem.linkName) + " ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "addBookrack"
  }, [_c('a', {
    staticClass: "addBookrackBtn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.addBookrack()
      }
    }
  }, [_vm._v("加入书架")])]), _vm._v(" "), _c('recommend'), _vm._v(" "), _c('bookDetails-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookDetails-titleBox"
  }, [_c('span', {
    staticClass: "bookDetails-title"
  }, [_vm._v("作品详情")])])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classifydetails"
  }, [_c('div', {
    staticClass: "classifydetails-topBar"
  }, [_c('div', {
    staticClass: "classifydetails-topNav"
  }, [_c('div', {
    staticClass: "classifydetails-topNav-left"
  }, [_c('div', {
    staticClass: "classifydetails-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-titleBox"
  }, [_c('span', {
    staticClass: "classifydetails-title"
  }, [_vm._v(_vm._s(_vm.$route.params.classifydetailsTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-topNav-right"
  }, [_c('div', {
    staticClass: "classifydetails-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-container"
  }, [_c('ul', _vm._l((_vm.classifydetailsList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "classifydetails-img"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + _vm.catalogId
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "classifydetails-info"
    }, [_c('p', {
      staticClass: "classifydetails-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-sub1"
    }, [_vm._v(_vm._s(item.sub1))]), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-sub2",
      domProps: {
        "innerHTML": _vm._s('★简介★' + item.sub2)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-subTag"
    }, [_c('span', {
      staticClass: "classifydetails-tags"
    }, [_vm._v(_vm._s(item.tags))]), _vm._v(" "), _c('span', {
      staticClass: "classifydetails-reading"
    }, [_vm._v(_vm._s(item.reading))]), _vm._v(" "), _c('span', {
      staticClass: "classifydetails-bytime"
    }, [_vm._v(_vm._s(item.bytime))])])])])
  }))]), _vm._v(" "), _c('classifydetails-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-container"
  }, [_c('ul', _vm._l((_vm.catalogList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + item.id + '&' + item.catalog,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.catalog))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("分类页面")])])
}]}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booklist"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "rank-container"
  }, [_c('ul', _vm._l((_vm.rankSort), function(item) {
    return _c('li', [_c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id,
        "tag": "a"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('p', [_vm._v("★" + _vm._s(item.sub1) + "★")])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("推荐书单")])])
}]}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('index-topbar'), _vm._v(" "), _c('swiper'), _vm._v(" "), _c('div', {
    staticClass: "router"
  }, [_c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/classify"
    }
  }, [_c('a', {
    staticClass: "routerImg classifyBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "分类"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("分类")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/rank"
    }
  }, [_c('a', {
    staticClass: "routerImg rankBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "排行"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("排行")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/women"
    }
  }, [_c('a', {
    staticClass: "routerImg womenBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "女区"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("女区")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/men"
    }
  }, [_c('a', {
    staticClass: "routerImg menBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "男区"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("男区")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/booklist"
    }
  }, [_c('a', {
    staticClass: "routerImg listBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "书单"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("书单")])], 1)]), _vm._v(" "), _c('index-content'), _vm._v(" "), _c('index-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookrack"
  }, [_c('div', {
    staticClass: "bookrack-topBar"
  }, [_c('div', {
    staticClass: "bookrack-topNav"
  }, [_c('div', {
    staticClass: "bookrack-topNav-left"
  }, [_c('div', {
    staticClass: "bookrack-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bookrack-topNav-right"
  }, [_c('div', {
    staticClass: "bookrack-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bookrack-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bookrack-container"
  }, [(_vm.bookDetailList.length > 0) ? _c('ul', _vm._l((_vm.bookDetailList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.catalogId
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.bookDetailList.length == 0) ? _c('div', [_vm._v("\n      书架还没有东西\n      "), _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("去书城逛逛")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearBookrack"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.clearBookrack();
        _vm.$router.go(0)
      }
    }
  }, [_vm._v("一键清空书架")])]), _vm._v(" "), _c('recommend'), _vm._v(" "), _c('bookrack-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookrack-titleBox"
  }, [_c('span', {
    staticClass: "bookrack-title"
  }, [_vm._v("我的书架")])])
}]}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(157),
      "width": "100%/"
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(158),
      "width": "100%/"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-scrollbar",
    slot: "scrollbar"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "men"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-container"
  }, [_c('ul', _vm._l((_vm.catalogList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + item.id + '&' + item.catalog,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.catalog))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("男生专区")])])
}]}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "login-headerBack",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-headerHome"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "login-contentForm"
  }, [_c('div', {
    staticClass: "login-contentUserName"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.phone),
      expression: "phone",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "phone",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = _vm._n($event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "errorTxt"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-headerTitle"
  }, [_c('span', [_vm._v("注册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentLoginBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("获取验证码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentTip"
  }, [_c('p', [_vm._v("点击上面“登录”按钮")]), _vm._v(" "), _c('p', [_vm._v("即表示您同意"), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《阿里文学用户服务协议》")]), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《隐私服务协议》")])])])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "login-headerBack",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-headerHome"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "login-contentForm"
  }, [_c('div', {
    staticClass: "login-contentUserName"
  }, [_c('label', {
    attrs: {
      "for": "userName"
    }
  }, [_vm._v("账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userName),
      expression: "userName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "userName",
      "placeholder": "请输入手机号/邮箱"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-contentPassword"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('Icon', {
    staticClass: "login-contentPassword-eye",
    attrs: {
      "type": "ios-eye-outline",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "login-contentAuthCode"
  }, [_c('label', {
    attrs: {
      "for": "authCode"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.authCode),
      expression: "authCode",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "authCode"
    },
    domProps: {
      "value": (_vm.authCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authCode = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "login-contentChangeCode"
  }, [_vm._v("换一换")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "errorTxt"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-contentOtherOption"
  }, [_c('a', {
    staticClass: "login-forgetPsw",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/register"
    }
  }, [_c('a', {
    staticClass: "login-register",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(" 注册 ")])])], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-headerTitle"
  }, [_c('span', [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentLoginBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentTip"
  }, [_c('p', [_vm._v("点击上面“登录”按钮")]), _vm._v(" "), _c('p', [_vm._v("即表示您同意"), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《阿里文学用户服务协议》")]), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《隐私服务协议》")])])])
}]}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-header"
  }, [_c('div', {
    staticClass: "search-headerBack",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-headerHome"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-searchBox"
  }, [_c('label', {
    attrs: {
      "for": "searchBox"
    }
  }, [_c('Icon', {
    staticClass: "searchIcon",
    attrs: {
      "type": "android-search",
      "size": "22",
      "color": "#007AFF"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchMsg),
      expression: "searchMsg",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "searchBox",
      "placeholder": "书名/作者/关键词"
    },
    domProps: {
      "value": (_vm.searchMsg)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchMsg = $event.target.value.trim()
      }, function($event) {
        _vm.getSearch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCloseIcon),
      expression: "showCloseIcon"
    }],
    staticClass: "closeIcon",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.clearSearchMsg()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close-outline",
      "size": "18"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [(_vm.showRecomSearch) ? _c('div', {
    staticClass: "recomSearch"
  }, [_c('ul', _vm._l((_vm.recomSearchArr), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.showSearchList) ? _c('div', {
    staticClass: "searchList"
  }, [_c('ul', [_vm._l((_vm.handleSearchListArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.showSearchData(item.title)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
  }), _vm._v(" "), (_vm.handleSearchListArr.length == 0) ? _c('li', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v("无搜索结果！")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showSearchResult) ? _c('div', {
    staticClass: "searchResult"
  }, [_c('ul', _vm._l((_vm.searchResultArr), function(item) {
    return _c('li', [_c('router-link', {
      staticClass: "searchResult-img",
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }))]) : _vm._e()]), _vm._v(" "), (_vm.searchHistoryList.length > 0) ? _c('div', {
    staticClass: "search-history"
  }, [_c('div', {
    staticClass: "search-historyHeader"
  }, [_c('span', {
    staticClass: "search-historyTitle"
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('span', {
    staticClass: "search-historyDelBtn",
    on: {
      "click": function($event) {
        _vm.clearHistory()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-a",
      "size": "30"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-historyContent"
  }, [_c('ul', _vm._l((_vm.searchHistoryList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.showSearchData(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('search-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-headerTitle"
  }, [_c('span', [_vm._v("搜索中心")])])
}]}

/***/ })
],[96]);


// WEBPACK FOOTER //
// static/js/app.67e006f86b16e69ca3d9.js